let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6j79B")).then(() => parcelRequire('Ep8H8'));